import { makeStyles } from "@mui/styles";
import { Grid, IconButton, Input, TableCell, Typography, useTheme } from "@mui/material";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CachedIcon from '@mui/icons-material/Cached';
import { THEME } from "../../../config";
import StyledTooltip from "../../../components/Misc/StyledTooltip";

const useStyles = makeStyles(() => ({
    title: {
        fontWeight: 500,
        fontSize: "1rem",
    },
    titleDisabled: {
        opacity: "50%",
        fontWeight: 500,
        fontSize: "1rem",
    },
    iconButton: {
        opacity: "100%"
    },
    iconButtonDisabled: {
        opacity: "50%"
    },
    iconInfo: {
        marginLeft: "10px",
        position: "relative",
        top: "5px",
        color: THEME.palette.primary.main
    },
    tableCell: {
        paddingRight: 0,
        paddingLeft: 0,
        [useTheme().breakpoints.down("sm")]: {
            paddingLeft: "1rem"
        }
    },
    gridSlider: {
        paddingRight: "5%"
    },
    slider: {
        markLabel: {
            color: "red"
        }
    },
    typographyName: {
        opacity: "100%",
        fontSize: "0.8rem",
        color: "gray"
    },
    typographyNameDisabled: {
        opacity: "50%",
        fontSize: "0.8rem",
        color: "gray"
    }
}))

interface IDoubleInputCell {
    title: string
    info?: string
    active: boolean
    colSpan: number
    qualityImageSize: [number, number, number]
    saveSetting: (w: number, h: number) => void
}

const DoubleInputCell: React.FC<IDoubleInputCell> = (props) => {
    
    const classes = useStyles();

    const handleWidthChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.saveSetting(Number(event.target.value), props.qualityImageSize[1])
    }

    const handleHeightChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        props.saveSetting(props.qualityImageSize[0], Number(event.target.value))
    }

    const handleIconClick = () => {
        props.saveSetting(960, 540)
    }

    return (
        <TableCell colSpan={props.colSpan} className={classes.tableCell}>
            <Grid container>
                <Grid item xs={12}>
                    <Typography component={'span'} className={props.active? classes.title : classes.titleDisabled}>
                        {props.title}
                        {props.info? 
                            <StyledTooltip disableFocusListener title={props.info} >
                                <div style={{display: "inline"}} >
                                    <HelpOutlineIcon className={classes.iconInfo} />
                                </div>
                            </StyledTooltip>
                        : null}
                    </Typography>
                </Grid>
                <Grid container>
                    <Grid item xs={3} className={classes.gridSlider}>
                        <Typography className={props.active? classes.typographyName : classes.typographyNameDisabled}>
                            Width
                        </Typography>
                        <Input
                            disabled={!props.active}
                            placeholder="W"
                            value={(960 * 540) === props.qualityImageSize[2]? props.qualityImageSize[0] : undefined}
                            onChange={handleWidthChange}
                            inputProps={{
                                step: 10,
                                min: 0,
                                type: 'number',
                                'aria-labelledby': 'input-slider',
                            }}
                            color="primary"
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <Typography className={props.active? classes.typographyName : classes.typographyNameDisabled}>
                            Height
                        </Typography>
                        <Input
                            disabled={!props.active}
                            placeholder="H"
                            value={(960 * 540) === props.qualityImageSize[2]? props.qualityImageSize[1] : undefined}
                            onChange={handleHeightChange}
                            inputProps={{
                                step: 10,
                                min: 0,
                                type: 'number',
                                'aria-labelledby': 'input-slider',
                            }}
                            color="primary"
                        />
                    </Grid>
                    <Grid item xs={4} style={{paddingLeft: "6px"}}>
                        <Typography className={props.active? classes.typographyName : classes.typographyNameDisabled}>
                            Total:
                        </Typography>
                        <Typography className={props.active? classes.typographyName : classes.typographyNameDisabled}>
                            <b>{props.qualityImageSize[2]} px</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={2}>
                        <IconButton onClick={handleIconClick} color="primary" className={props.active? classes.iconButton : classes.iconButtonDisabled}>
                            <CachedIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            </Grid>
        </TableCell>
    );
}

export default DoubleInputCell